export default "__VITE_ASSET__96190e52__"